<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Tests Results: Imaging Tests
        </h2>

        <div class="flex flex-col md:flex-row gap-8">
            <div class="flex-1">
                <h3 class="text-2xl font-semibold mb-6">Kidney imaging results</h3>
                <ul class="list-disc pl-4  font-light mb-6">
                    <li>Urgent abdominal and pelvic ultrasound (<span class="font-semibold">Figure 1</span>) showed increased left kidney echogenicity with a small stone (5 mm diameter, left) and minimal hydronephrosis (right)</li>
                </ul>

                <p class="bg-maroon p-5 text-white text-2xl font-semibold mb-6">Kidney stone</p>
                <ul class="list-disc pl-4  font-light mb-6">
                    <li>Non-contrast abdominal and pelvic CT scan (<span class="font-semibold">Figure 2</span>) showed the right kidney to be small and atrophic with multiple tiny stones (2 mm) and increased renal pyramid density with associated pelvicalyceal system fullness</li>
                    <ul class="list-inside list-['-_'] pl-6">
                        <li>The largest stone was in the upper calyx (5 mm), with mild hydronephrosis and increased pyramidal density</li>
                    </ul>
                    <li>All other features evaluated were deemed normal on <br />kidney imaging</li>
                </ul>
            </div>

            <div class="flex-2 flex flex-col gap-6">
                <div class="flex-1">
                    <p class=" font-light mb-2">Figure 1: Abdominal and pelvic ultrasound</p>

                    <div class="flex flex-col lg:flex-row gap-2">
                        <img
                            src="@/assets/img/graphics/adolescent/imaging-test.svg"
                            alt="Abdominal and pelvic ultrasound 1"
                            class="object-contain flex-1 min-w-0"
                        />

                        <img
                            src="@/assets/img/graphics/adolescent/abdominal-usg-2.png"
                            alt="Abdominal and pelvic ultrasound 2"
                            class="object-contain flex-1  min-w-0"
                        />
                    </div>
                </div>

                <div class="flex-1">
                    <p class=" font-light mb-2">Figure 2: Abdominal and pelvic non-contrast CT scan</p>

                    <div class="flex flex-col lg:flex-row gap-2">
                        <img
                            src="@/assets/img/graphics/adolescent/abdominal-ct-1.png"
                            alt="Abdominal and pelvic CT 1"
                            class="object-contain flex-1  min-w-0"
                        />

                        <img
                            src="@/assets/img/graphics/adolescent/abdominal-ct-2.png"
                            alt="Abdominal and pelvic CT 2"
                            class="object-contain flex-1  min-w-0"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
